<template>
  <div>
    <v-row class="pt-4 pb-5 d-flex justify-center align-center">
      <v-col cols="12">
        <span class="font-weight-medium">Selecione um valor</span>
      </v-col>
      <v-col cols="12" class="text-center pa-md-0" :style="'center;'">
        <input-number
          format="currency"
          required
          solo
          flat
          hide-details
          autofocus
          value-when-is-empty="0,00"
          class="centered-input font-weight-medium vlrSelecionado"
          style="
            font-size: 32px;
            font-weight: 600;
            line-height: 42px;
            letter-spacing: normal;
          "
          @change="change"
          @input="inputVal"
          v-model="model"
          :max="max"
          :min="min"
          :rules="ruleVlrSolicitado"
          :outlined="false"
        >
        </input-number>
        <template> </template>
      </v-col>
    </v-row>
    <v-row>
      <v-slider
        :step="step"
        :ticks="ticks"
        ref="slider"
        class="trad-slider"
        thumb-label="always"
        thumb-size="3"
        v-model="valorSliderSelecionado"
        @input="inputSlider"
        @change="change"
        :max="max"
        :min="min"
        :error="model > max || model < min"
        required
      >
        <template slot="thumb-label">
          <v-img
            style="margin-top: 30px"
            src="../assets/icons/sliderIcon.svg"
          />
        </template>
      </v-slider>
    </v-row>
    <v-row class="d-flex justify-end align-center">
      <v-col cols="6" class="pt-0 pb-3 text-left">
        <span class="font-weight-medium">
          R$ {{ $api.UI.Format.Decimal(min) }}
        </span>
      </v-col>
      <v-col cols="6" class="pt-0 pb-3 text-right">
        <span class="font-weight-medium">
          R$ {{ $api.UI.Format.Decimal(max) }}
        </span>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    min: Number,
    max: Number,
    value: Number,
    limite: null,
    step: { type: Number, default: 0 },
    ticks: { type: Boolean, default: true },
  },
  data () {
    return {
      valorSliderSelecionado: 0
    }
  },
  computed: {
    model: {
      get () {
        return this.value;
      },
      set (value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    ruleVlrSolicitado () {
      if (this.model < this.min) {
        return [
          this.model > this.min || 'Valor informado é menor que o valor mínimo',
        ];
      } else if (this.model < 0) {
        return [this.model > 0 || 'Informe o valor do empréstimo'];
      }
    },
    inputSlider (value) {
      if (!this.controlValue && value !== this.model) {
        this.$set(this, 'model', value);
      }
    },
    inputVal (value) {
      if (value !== this.valorSliderSelecionado) {
        this.controlValue = true;
        this.$set(this, 'valorSliderSelecionado', value);
      }
      setTimeout(() => {
        this.controlValue = false;
      }, 100);
    },
    change (value) {
      this.$emit('change', value);
    },
  },
  mounted () {
    this.$emit('mounted');
  },
};
</script>
<style>
  .v-text-field__prefix{
    color: #000 !important;
  }
</style>
